import { render, staticRenderFns } from "./productCard.vue?vue&type=template&id=045100d8&scoped=true&"
import script from "./productCard.vue?vue&type=script&lang=js&"
export * from "./productCard.vue?vue&type=script&lang=js&"
import style0 from "./productCard.vue?vue&type=style&index=0&id=045100d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045100d8",
  null
  
)

export default component.exports